import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=f72f1f38&scoped=true"
import script from "./Limits.vue?vue&type=script&lang=js"
export * from "./Limits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72f1f38",
  null
  
)

export default component.exports